<template>
	<div id="pc" @click="clickDocument">
		<header style="color: #fff;" :class="curPage == 1 ? 'topheader topheaderbg' : 'topheader' " v-if="commonfontColor == 'font_white'">
			<div class="toheader_left">
				<div class="headerlogo" @click="gotoIndex(1)"><img src="../assets/logowhite.png" ></div>
				<span @click="gotoIndex(1)" :class="curPage == 1 ? 'curBorderW': ''">Games</span>
				<span @click="gotoIndex(2)" :class="curPage == 2 ? 'curBorderW': ''">Contact</span>
			</div>
		</header>
		 <full-page ref="slideContainer" :options="options" @leave="beforeLoad">
		      <div class="section">
				  <Banner1 :curpage="curPage" :aniDownUp="aniDownUp"></Banner1>
			  </div>
		      <div class="section">
				  <Banner2 :curpage="curPage" :aniDownUp="aniDownUp"></Banner2>
			  </div>
		</full-page>
	</div>
</template>

<script>
	import { SlideContainer, SlidePage } from 'vue-slidepage'
	import Banner1 from './pc/banner1.vue'
	import Banner2 from './pc/banner2.vue'
	export default {
		components: {	
		    SlideContainer,
		    SlidePage,
			Banner1,
			Banner2
		},
		props: {
			useAnimation: true,
			refresh: true,
			useWheel: true,
			useSwipe: true
		},
		watch: {
		},
		data () {
			return {
				options: {
					 menu: '#menu',
					      navigation: false,                                     //右边的小圆点导航
						  onLeave: this.beforeLoad,
						  refresh: true,
						  scrollingSpeed: 2000,
						  licenseKey: 'OPEN-SOURCE-GPLV3-LICENSE'
				},
				curPage: 1,
				cando: true,
				commonfontColor: 'font_white', // font_black
				aniDownUp: '' // 默认为空，向下滑动，则向下，向上滑动则向上
			}
		},
		methods: {
			beforeLoad (origin, destination, direction) {
				this.curPage = destination.index + 1
				this.aniDownUp = direction
			},
			scrollFunc (e) {
			    if (e.wheelDeltaY > 0) { //当滑轮向上滚动时
					if (this.curPage > 1 && this.cando) {
						this.curPage -= 1
						this.$refs['slideContainer'].slideTo(this.curPage)
					}
			    }
			    if (e.wheelDeltaY < 0) { //当滑轮向下滚动时
					if (this.curPage < 8 && this.cando) {
						this.curPage += 1
						this.$refs['slideContainer'].slideTo(this.curPage)
					}
			    }
			},
			onBefore(origin, direction, target) {
				this.cando = false
			},
			changeIndex (origin, direction, target) {
				// console.log('cando')
				setTimeout(() => {
				    this.cando = true
				},800)
			},
			clickDocument () {
				this.cando = true
			},
			// 切换语言
			changeLangue () {
				let locale = this.$i18n.locale
				console.log(locale, 'local')
				locale == 'cn' ? this.$i18n.locale = 'en' : this.$i18n.locale = 'cn'
				localStorage.setItem('user_lang', this.$i18n.locale)
			},
			gotoIndex (index) {
				this.curPage = index
				this.$refs['slideContainer'].api.moveTo(index)
			}
		}
	}
</script>

<style lang="scss">
	::v-deep .slider-btn {
		display: none !important;
	}
	body {
		height: 100vh;
		// background-color: forestgreen;
	}
	.slide-page {
	  position: absolute;
	  top: 0;
	  left: 0;
	  width: 100vw;
	  height: 100vh;
	  overflow-y: auto;
	  overflow-x: hidden;
	  -webkit-overflow-scrolling: touch;
	  -webkit-tap-highlight-color:rgba(255,255,255,0);
	  -webkit-text-size-adjust: none;
	  -webkit-backface-visibility:hidden;-webkit-transform-style:preserve-3d;
	  background-position: center;
	  transform: translate3d(0,100%,0);
	  -webkit-transform: translate3d(0,100%,0);
	}
	.slide-page.transition {
	  transition: all 500ms cubic-bezier(0.550, 0.085, 0.000, 0.990);
	  -webkit-transition: all 500ms cubic-bezier(0.550, 0.085, 0.000, 0.990);
	}
	#pc {
		margin: 0;
		width: 100vw;
		height: 100vh !important;
		min-height: 100vh;
		// padding-top: 80px;
		box-sizing: border-box;
		position: relative;
		overflow: hidden;
		font-family: 'PilatTest-Bold';
		// background-color: red;
		user-select: none;
		-moz-user-select: none;
		-webkit-user-select: none;
		-ms-user-select: none;
	}
	.font_black {
		color: #000;
	}
	.font_white {
		color: #fff;
	}
	.topheader {
		position: fixed;
		top: 0rem;
		width: 100vw;
		height: 80px;
		padding-bottom: 0;
		z-index: 999;
		text-align: left;
		display: flex;
		justify-content: space-between;
		font-family: 'PilatTest-Bold';
		font-size: 0.50rem;
		font-weight: 700;
		box-sizing: border-box;
		padding-left: 1.5625rem;
		margin: 0;
		.toheader_left {
			width: 80%;
			display: flex;
			justify-content: flex-start;
			cursor: pointer;
			.headerlogo {
				line-height: 3.5rem;
				position: relative;
				box-sizing: border-box;
				padding-left: 5.5rem;
				img {
					position: absolute;
					width: 2.7rem;
					top: 50%;
					transform: translateY(-50%);
					left: 0;
				}
			}
			span {
				display: inline-block;
				vertical-align: bottom;
				line-height: 80px;
				height: 80%;
				margin-right: 1.25rem;
				padding-bottom: 0;
				vertical-align: middle;
			}
			.curBorderW {
				line-height: 80px;
				height: 80%;
				border-bottom: 2px solid #fff;
				cursor: pointer;
			}
		}
		.right_text {
			display: inline-block;
			padding-top: 20px;
			font-size: 0.35rem;
			vertical-align: middle;
			margin-right: 1.25rem;
			padding-bottom: 0;
			margin-bottom: 0;
			vertical-align: bottom;
			height: 39px;
		}
		.header_logo_icon {
			font-size: 0.25rem;
			font-style: normal;
			vertical-align: super;
			margin-left: -5px;
		}
	}
	.topheaderbg {
		background-image: url(../assets/headerbg.png);
		// opacity: 0.92;
		background-color: red;
		background-repeat: no-repeat;
		background-size: cover;
		width: 100vw;
		
	}
	.full-page {
		padding: 0;
		margin: 0;
	}
</style>
